import {
  BUILDING_PREVIEW,
  BUILDING_NEW,
  BUILDING_UPDATE,
  BUILDING_REMOVE,
  BUILDING_PROCESS_SUCCESS,
  BUILDING_DATASOURCE_SUCCESS,
  BUILDING_SEARCH,
  BUILDING_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case BUILDING_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case BUILDING_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case BUILDING_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case BUILDING_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case BUILDING_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case BUILDING_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case BUILDING_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case BUILDING_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}